const listOfCategories = [
    "Breakfast",
    "Appetizers",
    "Soups/Stews",
    "Salads/Dressings",
    "Sandwiches",
    "Beef",
    "Poultry",
    "Pork",
    "Seafood",
    "Vegetables",
    "Pasta/Sauces",
    "Desserts",
    "Bread",
    "Bakery",
    "Rice/Grains",
    "Snacks",
    "Beverages",
    "Holiday"
];

export default listOfCategories;